export enum ReminderMoment {
    AFTER="AFTER",
    BEFORE="BEFORE"
}